<template>
  <div>
    <HoldingSummary :newFilter="filter"/>
  </div>
</template>

<script>
import HoldingSummary from '@/febos/global/operations/components/transactionality/HoldingSummary';

export default {
  name: 'HoldingDetail',
  components: { HoldingSummary },
  data() {
    return {
      filter: null
    };
  }
};
</script>

<style scoped>

</style>
